import { Controller } from "@hotwired/stimulus"

// Copy text to the clipboard from a Stimulus value rather than from an
// inline onclick attribute. This is the secure replacement for the previous
// pattern of `onclick="navigator.clipboard.writeText('<%= record.field %>')"`
// which was vulnerable to XSS when the record field contained user-controlled
// data (e.g. coin keys/values).
//
// Usage:
//   <button type="button"
//           data-controller="copy"
//           data-copy-text-value="<%= coin.value %>"
//           data-action="click->copy#run">
//     ...icon SVG...
//   </button>
//
// Rails' ERB output is HTML-attribute-escaped, so any quotes/angle brackets
// in the value are rendered as entities and the browser hands us back the
// original string via this.textValue — never parsed as HTML or JS.
export default class extends Controller {
  static values = { text: String }
  static targets = ["icon"]

  async run() {
    try {
      await navigator.clipboard.writeText(this.textValue)
      this.flashSuccess()
    } catch (err) {
      console.error("Clipboard copy failed:", err)
    }
  }

  flashSuccess() {
    // Match the prior UX: briefly tint the icon green to confirm the copy.
    const icon = this.hasIconTarget ? this.iconTarget : this.element.querySelector("svg")
    if (!icon) return
    icon.classList.add("text-green-500")
    setTimeout(() => icon.classList.remove("text-green-500"), 1000)
  }
}
